export default "__VITE_ASSET__DL8RW1nH__"